import { DateField, TextField } from '@mi-front/ui';
import { Grid } from '@mui/material';
import moment from 'moment-timezone';
import { useIntl } from 'react-intl';

export function LtxMatchesReportForm(_p: Record<string, unknown>) {
  const { $t } = useIntl();

  return (
    <Grid container spacing={2}>
      <Grid item xs={4}>
        <DateField
          name="date"
          label={$t({
            id: 'audit.reportsScreen.ltxMatches.date',
            defaultMessage: 'Fecha',
          })}
          isOutsideRange={(date) => moment(date) > moment()}
        />
      </Grid>
      <Grid item xs={4}>
        <TextField
          name="customId"
          label={$t({
            id: 'audit.reportsScreen.ltxMatches.customId',
            defaultMessage: 'ID material (opcional)',
          })}
        />
      </Grid>
    </Grid>
  );
}
